import { Box, Image, Text, VStack } from '@chakra-ui/react'
import LoadingAnimation from '@editor/assets/imgs/loading-animation-black.gif'

const LoadingPage = ({ text = '読み込み中…', zIndex = 10 }: { text?: string; zIndex?: number }) => (
  <Box
    w="100vw"
    h="100vh"
    position="absolute"
    top={0}
    left={0}
    backgroundColor="#000000"
    zIndex={zIndex}
    data-testid="loadingPage"
  >
    <VStack position="absolute" left="50%" top="50%" transform="translate(-50%, -50%)" alignItems="center">
      <Image src={LoadingAnimation} w={160} />
      <Text color="whiteAlpha.700" fontWeight="bold">
        {text}
      </Text>
    </VStack>
  </Box>
)

export default LoadingPage
